module.exports = __webpack_public_path__ + "static/media/side_ic_coin_1.e5c1ad42.png";